/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".sub-type-item[_ngcontent-%COMP%]{margin:12px 0}.sub-type-item[_ngcontent-%COMP%]   .sub-type-code[_ngcontent-%COMP%]{display:inline-block;background:#182365;color:#fff;padding:2px 8px;border-radius:4px;font-weight:700;font-size:12px;margin-right:8px;font-family:monospace}.sub-type-item[_ngcontent-%COMP%]   .sub-type-label[_ngcontent-%COMP%]{font-weight:600;font-size:14px}.sub-type-item[_ngcontent-%COMP%]   .sub-type-desc[_ngcontent-%COMP%]{margin:4px 0 0;color:rgba(0,0,0,.6);font-size:13px;line-height:1.4}"];
export { styles as styles };
